module.exports = __webpack_public_path__ + "img/gif-focus-es.04046230.gif";